import { billsBuyerOnToken } from '../../lib/giftRecipient';
import { GiftShipsTo } from '../../types/gql-op-types';
import type { StripeAddressValue } from './StripePaymentForm';

export function buyerBillingMissing(
  gift: { shipsTo: GiftShipsTo } | undefined,
  billingAddress: StripeAddressValue | undefined,
): boolean {
  return billsBuyerOnToken(gift) && !billingAddress;
}

/** a gift shipped to the recipient bills the buyer's own address, never the recipient's */
export function confirmationBillingDetails(
  email: string,
  shippingAddress: StripeAddressValue,
  billingAddress: StripeAddressValue | undefined,
) {
  const { name, phone, address } = billingAddress ?? shippingAddress;
  return {
    name,
    email,
    phone: phone ?? '',
    address: {
      line1: address.line1,
      line2: address.line2 ?? '',
      city: address.city,
      state: address.state,
      postal_code: address.postal_code,
      country: address.country,
    },
  };
}
